import axios from './axios';

export default new class {
    revokeSession(context) {
        localStorage.removeItem('token')
        axios.refreshToken()
        
        context.$router.push({ name: 'Inicio' })
    }
}